import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";
import { SpinnerPage } from "@components/pages/spinner-page/spinner-page";
import { FluidToFixSplitContainer } from "@components/templates/layouts/fluid-to-fix-split-container/fluid-to-fix-split-container";
import { MainContainer } from "@components/templates/layouts/main-container/main-container";
import { RoundBorderComponentContainer } from "@components/templates/layouts/round-border-component-container/round-border-component-container";
import { RootState } from "@src/reducers/store";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CreateConfigurationFile } from "./create-configuration-file";
import { LicensedConfigurationTable } from "./licensed-configuration-table";
import loadLicensedConfigurations from "@src/cloud-connect/use-cases/load-licensed-configurations";

export const ConfigurationManagerPage = () => {
  const { isReady, data, isError } = useSelector(
    (state: RootState) => state.yourSlice.licensedConfigurations,
  );

  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    if (isReady) {
      return;
    }

    loadLicensedConfigurations();
  }, []);

  if (!isReady) {
    return <SpinnerPage />;
  }

  return (
    <MainContainer>
      <Spacer16 />
      <RoundBorderComponentContainer>
        <FluidToFixSplitContainer noPadding>
          <LicensedConfigurationTable
            data={data}
            isError={isError}
            onCreateConfiguration={() => setShowCreate(true)}
          />
          {showCreate && (
            <CreateConfigurationFile onCancel={() => setShowCreate(false)} />
          )}
        </FluidToFixSplitContainer>
      </RoundBorderComponentContainer>
    </MainContainer>
  );
};
